import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MessikaModule } from '@src/clients/messika/messika.module';
import { environment } from '@src/environments/environment';
import { EnvironmentNames } from '@src/environments/environments.name';

if (environment.envName === EnvironmentNames.prod) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(MessikaModule)
  .catch(err => console.log(err));
